import { User } from '@/types/generated/common/auth'

export interface AuthState {
  isAuthenticated: boolean
  isLoading: boolean
  user: User | null
  accessToken: string | null
  refreshToken: string | null
  /** Login challenge only. Do not use as the persisted "2FA enabled" status. */
  requires2fa: boolean
  tempToken: string | null
  /** How the login awaiting `tempToken` started, so verify2FA reports the right method. */
  pendingLoginMethod?: 'email' | 'google'
  requiresEmailVerification: boolean
  isNewUser?: boolean
}

export const initialAuthState: AuthState = {
  isAuthenticated: false,
  isLoading: false,
  user: null,
  accessToken: null,
  refreshToken: null,
  requires2fa: false,
  tempToken: null,
  requiresEmailVerification: false,
  isNewUser: false,
}
